import ListingDetailLivestockForm from '@Forms/ListingDetailLivestockForm';
import PriceInfoLivestockForm from '@Forms/PriceInfoLivestockForm';
import SpecsSection from '@Sections/SpecsSection';

class LivestockInformationSection extends React.Component {
    
    //set the react state to the the same values as the model
    static modelToState(props) {
        return {
            LivestockViewModel: props.model.LivestockViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            IsLivestock: props.model.IsLivestock,
            QueryString: props.model.QueryString,
            CurrentSite: props.model.CurrentSite,
            Translations: props.model.Translations,
            IsRegisteredUser: props.model.IsRegisteredUser,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {}
        };
    }

    //The props is the model passed from the view(cshtml)
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.validateLivestockInfo = this.validateLivestockInfo.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.model;
        masterViewState.validateLivestockInfo = this.validateLivestockInfo;
        this.props.handleFormUpdate(masterViewState);

        this.state = LivestockInformationSection.modelToState(props);
    }

    componentWillReceiveProps(props) {
        this.setState({
            LivestockViewModel: props.model.LivestockViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            PriceViewModel: props.model.PriceViewModel,
            ContactViewModel: props.model.ContactViewModel,
            Translations: props.model.Translations
        });
    }

    //executes a command when you click on a button
    handleButtonClick(button) {

        switch (button) {
            case "done":
                var bHasErrors = this.validateLivestockInfo(true);

                if (!bHasErrors) {
                    // fire the addListingEquipment datalayer event here
                    if (!dataLayer_ContainsEvent(gTagEvents.addListingEquipment)) {
                        window.dataLayer.push({
                            "event": gTagEvents.addListingEquipment
                        });
                    }
                    EnterInfoDone();
                } 
                break;
            default:
                break;
        }
    }

    //updates the state in View with new values when they change. 
    handleFormUpdate(Model) {
        this.setState({
            LivestockViewModel: Model.LivestockViewModel || this.state.LivestockViewModel,
            SpecsViewModel: Model.SpecsViewModel || this.state.SpecsViewModel,
            ValidateAndSaveSpecs: Model.ValidateAndSaveSpecs || this.state.ValidateAndSaveSpecs,
            showUnitSwitchModal: Model.SpecsViewModel.showUnitSwitchModal || this.state.SpecsViewModel.showUnitSwitchModal,
            PriceViewModel: Model.PriceViewModel || this.state.PriceViewModel,
            validatorPrice: Model.validatorPrice || this.state.validatorPrice,
            validatorLivestockDetails: Model.validatorLivestockDetails || this.state.validatorLivestockDetails,
            validatorLivestockPriceInfo: Model.validatorLivestockPriceInfo || this.state.validatorLivestockPriceInfo,
            ContactViewModel: Model.ContactViewModel || this.state.ContactViewModel,
            validatorContact: Model.validatorContact || this.state.validatorContact,
            HighlightErrors: Model.HighlightErrors || this.state.HighlightErrors,
            FormErrors: Model.FormErrors || this.state.FormErrors,
            InputErrors: Model.InputErrors || this.state.InputErrors
        });

        //pass update up to MasterView
        this.props.handleFormUpdate(Model);
    }

    validateLivestockInfo(bSaveXML) {
        var bHasErrors = false;

        bHasErrors = this.state.validatorLivestockDetails(bSaveXML);

        if (this.state.InputErrors.LocationPicker) {
            bHasErrors = true;
        }

        if (!bHasErrors) {
            bHasErrors = this.state.validatorLivestockPriceInfo();
        }

        if (!bHasErrors) {
            bHasErrors = this.state.ValidateAndSaveSpecs(bSaveXML);
        }

        return bHasErrors;
    }

    handleKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleButtonClick("done");
            let tagetElement = this.state.IsRearrangedSite ? document.getElementById("dropbox") : document.getElementById("PrivacyBtn");
            setTimeout(() => {
                if (tagetElement) {
                    tagetElement.focus();
                }
            }, 0);
        }
    }

    render() {
        var doneText = "Done with Livestock Information";
        if (this.state.CurrentSite == "EquineMarket") {
            doneText = "Done with Horse Information";
        }
        return (
            <div className="accordion cf" id="accordion-content-2">
                
                <ListingDetailLivestockForm
                    parentState={this.state}
                    model={this.state.LivestockViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                />
                <PriceInfoLivestockForm
                    parentState={this.state}
                    model={this.state.LivestockViewModel.PriceInfoLivestockViewModel}
                    livestockViewModel={ this.state.LivestockViewModel}
                    SpecsViewModel={this.state.SpecsViewModel}
                    ValidateSpec={this.state.ValidateSpec}
                    SaveSpecsToXML={this.state.SaveSpecsToXML}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                />
                <SpecsSection
                    masterViewModel={this.state}
                    model={this.state.SpecsViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                />


                <button role="link" className="form-btn" id="info-done-btn" onKeyDown={(e) => { this.handleKeyDown(e) }} onMouseUp={(e) => { this.handleButtonClick("done"); }}>{doneText}</button>
            </div>
        );
    }
}

export default LivestockInformationSection;
global.LivestockInformationSection = LivestockInformationSection;